import { useQuery } from '@tanstack/react-query';

import { integrationsApi } from '../api';
import {
  CalendlyAvailableTimeSlot,
  CalendlyEventType,
  CalendlyIntegration,
} from '@demind-inc/core';

interface UseCalendlySlotsParams {
  calendlyIntegId: string;
  startDate: string;
  endDate: string;
}

interface UseCalendlySlotsQueryParams {
  queryKey: ['lifestack.integration.calendly.slots', UseCalendlySlotsParams];
}

export const useCalendlySlots = ({
  calendlyIntegId,
  startDate,
  endDate,
}: UseCalendlySlotsParams) => {
  const calendlySlotsQuery = useQuery({
    queryKey: ['lifestack.integration.calendly.slots', { calendlyIntegId, startDate, endDate }],
    queryFn: ({ queryKey }: UseCalendlySlotsQueryParams) => {
      const [, { calendlyIntegId, startDate, endDate }] = queryKey;

      return integrationsApi
        .getCalendlyAvailableSlots(calendlyIntegId, startDate, endDate)
        .then(({ data }) => ({
          slots: (data.slots ?? []) as CalendlyAvailableTimeSlot[],
          eventType: data.eventType as CalendlyEventType | undefined,
        }));
    },
    refetchOnWindowFocus: false,
    enabled: !!calendlyIntegId,
    staleTime: 60 * 60, // 1 min
  });

  return {
    ...calendlySlotsQuery,
    calendlySlots: calendlySlotsQuery.data,
  };
};
